@if (!isOnlyIndicationActive) {
  <nav
    class="mobile-navbar"
    [attr.aria-label]="'components.mobileNavbar.ariaLabel' | i18n"
  >
    @for (item of items; track item.id) {
      <button
        type="button"
        class="mobile-navbar__item"
        [class.mobile-navbar__item--active]="activeItem === item.id"
        [attr.data-mobile-search-trigger]="item.id === 'search' ? '' : null"
        (click)="onItemClick(item, $event)"
      >
        <span class="mobile-navbar__icon {{ item.icon }} mdn-Icon--md" aria-hidden="true"></span>
        <span class="mobile-navbar__label">{{ item.labelKey | i18n }}</span>
      </button>
    }
  </nav>
}
